var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('summary-group',{attrs:{"title":_vm.$t('setupSteps.setup-deployment'),"goTo":_vm.goToDeployment}},[_c('v-expansion-panels',{attrs:{"flat":""}},[_c('summary-bootstrap'),_c('summary-recurring')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }